import { createFeatureSelector } from '@ngrx/store';

import {
  ModalControlsSaveable,
  ModalControlsSaveableFactory,
} from '®shared/modals';

export const STATE_FEATURE_REQUEST_REVIEW = 'requestReview';

export interface RequestReviewState {
  listId: string | null;
  modalControls: ModalControlsSaveable;
}

export const REQUEST_REVIEW_INITIAL_STATE: RequestReviewState = {
  listId: null,
  modalControls: ModalControlsSaveableFactory.hide(),
};

export function getInitialRequestReviewState(): RequestReviewState {
  return REQUEST_REVIEW_INITIAL_STATE;
}

export const selectRequestReviewState =
  createFeatureSelector<RequestReviewState>(STATE_FEATURE_REQUEST_REVIEW);
